/*global mod*/

mod.modules.define("PrimarySymbolSearch", "SymbolSearchBase", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.el.modAutocomplete("option", "appendTo", ".mod_site_header");
		this.el.modAutocomplete("option", "position", {
			my: "left top",
			at: "left bottom",
			collision: "none",
			of: this.el.parent(),
			offset: "0 -4"
		});
	};

});